import { render, staticRenderFns } from "./PrintableProductBadge.vue?vue&type=template&id=3d3d050e&scoped=true&"
import script from "./PrintableProductBadge.vue?vue&type=script&lang=js&"
export * from "./PrintableProductBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d050e",
  null
  
)

export default component.exports